import { attributesToProps } from 'html-react-parser';
import Script from 'next/script';
import type { ParserProps } from '@/app_lib/htmlParser/types';

export const ScriptParser = ({ domNode }: ParserProps) => {
  const { attribs } = domNode;
  const props = attributesToProps(attribs);
  const scriptContent = domNode.children
    ?.map((child) => {
      if ('data' in child && typeof child.data === 'string') {
        return child.data;
      }
      return '';
    })
    .join('');
  return (
    <Script
      {...props}
      strategy='afterInteractive'
    >
      {scriptContent}
    </Script>
  );
};
